import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

import { DistributionRewardsAnimation } from "./DistributionRewardsAnimation";

/**
 * Distribution history, when the reporting call did not come back.
 *
 * Same shell as `DistributionHistoryEmpty`, and deliberately so: both
 * replace the table, both show the same animation at the same height,
 * and both centre a heading over one line of copy. Holding the two to one
 * framework is what lets them be told apart by content rather than by
 * layout.
 *
 * The copy carries the whole distinction. "No Rewards Distributed Yet" is a
 * fact about the protocol; this is a fact about the request. Collapsing
 * the two into one grey sentence is how a failed fetch came to read as an
 * account with no history.
 */
export function DistributionHistoryError(): React.ReactElement {
    return (
        <div className="flex flex-col items-center px-4 py-10 text-center">
            <DistributionRewardsAnimation />
            <Text variant="h3" render={<h3 />} className="text-foreground-base">
                Rewards Failed to Load
            </Text>
            <Text
                variant="small"
                render={<p />}
                className="text-foreground-neutral mt-2 max-w-sm text-balance"
            >
                Rewards continue to accrue. This error doesn’t affect your
                earnings.
            </Text>
        </div>
    );
}
